/*	Copyright (c) 1996 - 2026 NoWatt Ltd				*/
/*	  All Rights Reserved  											*/

import React, { useEffect, useState } from 'react';
import Layout from './Layout';

interface LoginPageProps {
  user: string | null;
  message?: string;
}

const LoginPage = ({ user, message }: LoginPageProps) => {
  const [showReset, setShowReset] = useState(false);

  useEffect(() => {
    const nav = document.getElementById('tf-menu');
    if (nav) nav.classList.remove('on');
  }, []);

  return (
    <Layout user={user}>
      <div id="tf-signin">
        <div className="overlay">
          <div className="container">
            <div className="row">
              <div className="col-md-12">
                <div className={`pr-wrap ${showReset ? 'show-pass-reset' : ''}`}>
                  <div className="pass-reset">
                    <label>Enter the email you signed up with</label>
                    <input type="email" placeholder="Email" />
                    <input
                      className="pass-reset-submit btn btn-success btn-sm"
                      type="submit"
                      value="Submit"
                      onClick={() => setShowReset(false)}
                    />
                  </div>
                </div>

                <div className="wrap">
                  <p className="form-title">Sign In</p>
                  <form className="login" method="post" action="/login">
                    <input type="text" name="email" placeholder="Username" />
                    <input type="password" name="password" placeholder="Password" />
                    <input className="btn btn-secondary btn-sm" type="submit" value="Sign In" />
                    <div className="remember-forgot">
                      <div className="row">
                        <div className="col-6 remember-content">
                          <div className="checkbox">
                            <label><input type="checkbox" /> Remember Me</label>
                          </div>
                        </div>
                        <div className="col-6 forgot-pass-content">
                          <a
                            className="forgot-pass"
                            href="#"
                            onClick={(e) => { e.preventDefault(); setShowReset((v) => !v); }}
                          >
                            Forgot Password
                          </a>
                        </div>
                      </div>
                      <div className="row">
                        <p />
                        {message && (
                          <div className="alert alert-danger fade show">
                            <strong>{message}</strong>
                            <button className="btn-close" type="button" data-bs-dismiss="alert" aria-label="close" />
                          </div>
                        )}
                      </div>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Layout>
  );
};

export default LoginPage;
